import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import {
  AppBar,
  Grid,
  LinearProgress,
  Tab,
  Tabs,
} from '@material-ui/core';
import {
                                                          // renderErrorText,
  renderSnackbarError,
  renderSnackbarSavedNotification,
} from '../form-global-components/components-form-components-for-react-final-form';
import {
  ButtonSave,
  ButtonSaveAndClose,
} from 'theme';
import Save from '@material-ui/icons/Save';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import asyncValidate from './components/asyncValidate';
import { TabContainer } from '../custom-tab-container/custom-tab-container';

import EditViewClientTabName from './components/tab-name';
import EditViewClientTabDates from './components/tab-dates';
import EditViewClientTabAddress from './components/tab-address';

import EditViewClientTabIntakeAssessment from './components/tab-intake-assessment';
import EditViewClientTabResidentialCMPrograms from './components/tab-residential-cm-programs';
// import FormFieldsClientsTabsTabResidentialCMPrograms from 'components/form-fields-clients-tabs/tab-residential-cm-programs/tab-residential-cm-programs-hooks';
import EditViewClientTabVoluntaryProgramActivity from './components/tab-voluntary-program-activity';
import EditViewClientTabDischargeTermination from './components/tab-discharge-termination';

import EditViewClientTabPrograms from './components/tab-programs';
import EditViewClientTabClientDetails from './components/tab-client-details';
import EditViewClientTabOutcome from './components/tab-outcome';
import EditViewClientTabChangeLog from './components/tab-changelog';

  /*** signed in user */
  import  CONTEXT_USER_FOR_CLASS_COMPONENTS_FOR_COMPONENTS  from 'components/UserContext-FOR-CLASS-COMPONENTS/UserContext-FOR-CLASS-COMPONENTS'

class ClientEdit extends Component {  
  /*** signed in user */
  static contextType = CONTEXT_USER_FOR_CLASS_COMPONENTS_FOR_COMPONENTS  
  

  constructor(props) {
    super(props);
    this.state = {
      headerTabs: 0,
      subHeaderTabs1: 1,
      radio1Change: 0,
      select1Change: 0,
    };
  }
  componentDidUpdate() {
    /*** fix double render issue - start */
		if(this.props.match.params.id && !this.props.initialized)
			this.props.initialize(this.props.initialValues);
    /*** fix double render issue - end */
  }
  componentDidMount() {
    /*** fix double render issue - start */
    this.props.initialize(this.props.initialValues);
    /*** fix double render issue - end */
  }

  handleChangeHeader1 = (event, value) => {
    event.persist();
    this.setState({ headerTabs: value });
  }

  handleSubmitChangeProgram = () => {
          /*** signed in user */
          const c_USER = this.context  

    var params = {
      /*** tab-name */
      'regid': this.props.currentFormState.regid,
      'fname': this.props.currentFormState.fname,
      'mname': this.props.currentFormState.mname,
      'lname': this.props.currentFormState.lname,
      'dob': this.props.currentFormState.dob,
      'gender': this.props.currentFormState.gender,
      'ethnicity': this.props.currentFormState.ethnicity,

      /*** tab-address */
      'street': this.props.currentFormState.street,
      'city': this.props.currentFormState.city,
      'state': this.props.currentFormState.state,
      'zip': this.props.currentFormState.zip,

      'phonenumber': this.props.currentFormState.phonenumber,
      'emergencycontact': this.props.currentFormState.emergencycontact,
      'emergencycontactnumber': this.props.currentFormState.emergencycontactnumber,

        /*** tab-programs - BOP RRC - Officer */
        'bopsupervisingofficercomments': this.props.currentFormState.bopsupervisingofficercomments , 

        /*** tab-programs - BOP RRC - Program Requirements */
        'bopalchoholaftercareprogram': this.props.currentFormState.bopalchoholaftercareprogram , 
        'bopdrugaftercareprogram': this.props.currentFormState.bopdrugaftercareprogram , 
        'bopfinancialresponsibilityprogram': this.props.currentFormState.bopfinancialresponsibilityprogram , 
        'bopmentalhealthaftercareprogram': this.props.currentFormState.bopmentalhealthaftercareprogram , 
        'boppsf': this.props.currentFormState.boppsf , 

        /*** tab-programs - BOP RRC - BOP Institution */
        'boplevelofsecurity': this.props.currentFormState.boplevelofsecurity,
        'bopinstitution': this.props.currentFormState.bopinstitution,
        'bopinstitutioncomments': this.props.currentFormState.bopinstitutioncomments,

        /*** tab-programs - BOP RRC - Gang Affiliation */
        'bopgangaffiliation': this.props.currentFormState.bopgangaffiliation,
        'bopgangaffiliationcomments': this.props.currentFormState.bopgangaffiliationcomments,

        /*** tab-programs - OPC US PTS-Psy - Officer */
        'opcusptspsyofficercomments': this.props.currentFormState.opcusptspsyofficercomments,






        /*** tab-client-details */
        /*** tab-client-details - tab-conditions */
        'clienthomelesshistory': this.props.currentFormState.clienthomelesshistory,
        'clienthomelesscurrent': this.props.currentFormState.clienthomelesscurrent,
        'clienthomelessna': this.props.currentFormState.clienthomelessna,
        'clientmentalhealthissueshistory': this.props.currentFormState.clientmentalhealthissueshistory,
        'clientmentalhealthissuescurrent': this.props.currentFormState.clientmentalhealthissuescurrent,
        'clientmentalhealthissuesna': this.props.currentFormState.clientmentalhealthissuesna,
        'clientsubstanceusedisorderissueshistory': this.props.currentFormState.clientsubstanceusedisorderissueshistory,
        'clientsubstanceusedisorderissuescurrent': this.props.currentFormState.clientsubstanceusedisorderissuescurrent,
        'clientsubstanceusedisorderissuesna': this.props.currentFormState.clientsubstanceusedisorderissuesna,
        'clientcooccurringhistory': this.props.currentFormState.clientcooccurringhistory,
        'clientcooccurringcurrent': this.props.currentFormState.clientcooccurringcurrent,
        'clientcooccurringna': this.props.currentFormState.clientcooccurringna,
        'clientemployedduringpasthistory': this.props.currentFormState.clientemployedduringpasthistory,
        'clientemployedduringpastcurrent': this.props.currentFormState.clientemployedduringpastcurrent,
        'clientemployedduringpastna': this.props.currentFormState.clientemployedduringpastna,
        'clientprescribedmedications': this.props.currentFormState.clientprescribedmedications,
        'clientmedicationsupplyprovided': this.props.currentFormState.clientmedicationsupplyprovided,

        /*** tab-client-details - tab-education */
        'educationcompleted': this.props.currentFormState.educationcompleted,

        /*** tab-client-details - tab-referral */
        'referralsource': this.props.currentFormState.referralsource,
        'priorcriminalbackground': this.props.currentFormState.priorcriminalbackground,
        'currentinstantoffense': this.props.currentFormState.currentinstantoffense,

        /*** tab-client-details - tab-support */
        'supportsystem': this.props.currentFormState.supportsystem,
        'supportsystemcomments': this.props.currentFormState.supportsystemcomments,
        'numberofchildren': this.props.currentFormState.numberofchildren,
        'drugscreenscore': this.props.currentFormState.drugscreenscore,
        'primarybehavioralhealthdiagnosis': this.props.currentFormState.primarybehavioralhealthdiagnosis,
        'secondarybehavioralhealthdiagnosis': this.props.currentFormState.secondarybehavioralhealthdiagnosis,
        'behavioralhealthdiagnosiscomment': this.props.currentFormState.behavioralhealthdiagnosiscomment,
        'clienthomelesshowmanyweekspastyear': this.props.currentFormState.clienthomelesshowmanyweekspastyear,
        'clientemployedhowmanyweekspastyear': this.props.currentFormState.clientemployedhowmanyweekspastyear,
        'clientsourceofincome': this.props.currentFormState.clientsourceofincome,
        'clientrisktoselfothers': this.props.currentFormState.clientrisktoselfothers,
        'clientintakeandassessmentcomments': this.props.currentFormState.clientintakeandassessmentcomments,
        'clientrisktoselfotherscomment': this.props.currentFormState.clientrisktoselfotherscomment,
        'prescribedmedications': this.props.currentFormState.prescribedmedications,
        'medicationsupplyprovidedwithclient': this.props.currentFormState.medicationsupplyprovidedwithclient,
        'residentwithdisabilities': this.props.currentFormState.residentwithdisabilities,
        'clientisveteran': this.props.currentFormState.clientisveteran,
        'limitedenglishproficiency': this.props.currentFormState.limitedenglishproficiency,
        'limitedenglishproficiencycomments': this.props.currentFormState.limitedenglishproficiencycomments,
        'clientidentifiedsexualorientation': this.props.currentFormState.clientidentifiedsexualorientation,
        'interviewerperceptionofsexualorientation': this.props.currentFormState.interviewerperceptionofsexualorientation,


        /*** Client required */
        'refid': this.props.currentFormState.refid,
        'clientpostadmissiondate': this.props.currentFormState.clientpostadmissiondate,


        /*** Client Tabs Intake Assessment */
        'clientrecidivismriskscorenumber': this.props.currentFormState.clientrecidivismriskscorenumber,
        'clientrecidivismriskscorelevel': this.props.currentFormState.clientrecidivismriskscorelevel,
        'clientriskofvictimization': this.props.currentFormState.clientriskofvictimization,
        'clientriskasperpetrator': this.props.currentFormState.clientriskasperpetrator,
        'clientemployedduringprogram': 0,
        'clienthousingduringprogram': 0,
        
        'clientrrchdeligibilitydate': this.props.currentFormState.clientrrchdeligibilitydate,
        'clientbhtsopreferralcompleted': this.props.currentFormState.clientbhtsopreferralcompleted,

        /*** Client Tabs Crosspoint Programing */
        'clientlifeskills': this.props.currentFormState.clientlifeskills,
        'clientjobteadinesstraining': this.props.currentFormState.clientjobteadinesstraining,
        'clientcbtprogramming': this.props.currentFormState.clientcbtprogramming,
        'clientcbtprogramminghourscomplete':  this.props.currentFormState.clientcbtprogramminghourscomplete,
        'clientparenting': this.props.currentFormState.clientparenting,
        'clientwellness': this.props.currentFormState.clientwellness,
        'clientfinancialliteracy': this.props.currentFormState.clientfinancialliteracy,
        'crosspointbehavioralhealthservices': this.props.currentFormState.crosspointbehavioralhealthservices,


        /*** Client Tabs Voluntary Program Activities */
        'clientcommunityvolunteerprojects': this.props.currentFormState.clientcommunityvolunteerprojects,
        'clientcommunityvolunteerprojectscompleted':  this.props.currentFormState.clientcommunityvolunteerprojectscompleted,
        'clientaana': this.props.currentFormState.clientaana,
        'clientfaithbased': this.props.currentFormState.clientfaithbased,
        'clientadulteducation': this.props.currentFormState.clientadulteducation,
        'clientadulteducationcomments':  this.props.currentFormState.clientadulteducationcomments,
        'clientcompletedadulteducation': this.props.currentFormState.clientcompletedadulteducation,
        'clientrecoverycoachengagement': this.props.currentFormState.clientrecoverycoachengagement,
        'clientmedicationassistedtherapy': this.props.currentFormState.clientmedicationassistedtherapy,


        /*** Client Tabs Discharge / Termination */
        // 'clientdischargedate': this.props.currentFormState.clientdischargedate === '0000-00-00' ? null : this.props.currentFormState.clientdischargedate,
        'clientdischargedate': this.props.currentFormState.clientdischargedate,
        'clientemployedatdischarge': this.props.currentFormState.clientemployedatdischarge,
        'clienthousingatdischarge': this.props.currentFormState.clienthousingatdischarge,
        'clientdischargezipcode': this.props.currentFormState.clientdischargezipcode,
        'clientbehavioralhealthprogramsduringprogramstay': this.props.currentFormState.clientbehavioralhealthprogramsduringprogramstay,

        'clientearningshourlyrate': this.props.currentFormState.clientearningshourlyrate,
        'clientgrosssavings': this.props.currentFormState.clientgrosssavings,
        'clientbenefitapplicationinitiated': this.props.currentFormState.clientbenefitapplicationinitiated,
        'clientbenefitsawarded': this.props.currentFormState.clientbenefitsawarded,

        'clientrrctransfertohomeconfinement': this.props.currentFormState.clientrrctransfertohomeconfinement,
        'clientrrchomeconfinementatrelease': this.props.currentFormState.clientrrchomeconfinementatrelease,
        'clientrrcoverallgrossearningsytd': this.props.currentFormState.clientrrcoverallgrossearningsytd,
        'clientbhtssocialdeterminantsurvey': this.props.currentFormState.clientbhtssocialdeterminantsurvey,
        'clientbhtspostdischargeopenrolled': this.props.currentFormState.clientbhtspostdischargeopenrolled,
        
        'clientspotlightcandidate': this.props.currentFormState.clientspotlightcandidate,
        /*** FIXED cannot be changed and saved here ONLY in SAVE & CLOSE */
        'clientdischargestatus': 1,
        'clientdischargesubstatus': 0,
        'clientdischargestatuscomments': this.props.currentFormState.clientdischargestatuscomments,

        // 'clientlasttouchedbyloginid': this.props.currentUser.id,
        'clientlasttouchedbyloginid': c_USER.id,
        // 'clientlasttouchedbyloginid': contextType.id,

    };
                                                                        // console.log ('4444-505-879 - EditViewClient-AAA - handleSubmitChangeProgram - params = ', params);
    this.props.changeClientsProgram(this.props.match.params.id, params);
  }


  handleSubmitSave = () => {
              /*** signed in user */
              const c_USER = this.context  

    var params = {

      /*** tab-name */
      'regid': this.props.currentFormState.regid,
      'fname': this.props.currentFormState.fname,
      'mname': this.props.currentFormState.mname,
      'lname': this.props.currentFormState.lname,
      'dob': this.props.currentFormState.dob,
      'gender': this.props.currentFormState.gender,
      'ethnicity': this.props.currentFormState.ethnicity,

      /*** tab-address */
      'street': this.props.currentFormState.street,
      'city': this.props.currentFormState.city,
      'state': this.props.currentFormState.state,
      'zip': this.props.currentFormState.zip,

      'phonenumber': this.props.currentFormState.phonenumber,
      'emergencycontact': this.props.currentFormState.emergencycontact,
      'emergencycontactnumber': this.props.currentFormState.emergencycontactnumber,


        /*** tab-programs - BOP RRC - Officer */
        'bopsupervisingofficercomments': this.props.currentFormState.bopsupervisingofficercomments , 

        /*** tab-programs - BOP RRC - Program Requirements */
        'bopalchoholaftercareprogram': this.props.currentFormState.bopalchoholaftercareprogram , 
        'bopdrugaftercareprogram': this.props.currentFormState.bopdrugaftercareprogram , 
        'bopfinancialresponsibilityprogram': this.props.currentFormState.bopfinancialresponsibilityprogram , 
        'bopmentalhealthaftercareprogram': this.props.currentFormState.bopmentalhealthaftercareprogram , 
        'boppsf': this.props.currentFormState.boppsf , 

        /*** tab-programs - BOP RRC - BOP Institution */
        'boplevelofsecurity': this.props.currentFormState.boplevelofsecurity,
        'bopinstitution': this.props.currentFormState.bopinstitution,
        'bopinstitutioncomments': this.props.currentFormState.bopinstitutioncomments,

        /*** tab-programs - BOP RRC - Gang Affiliation */
        'bopgangaffiliation': this.props.currentFormState.bopgangaffiliation,
        'bopgangaffiliationcomments': this.props.currentFormState.bopgangaffiliationcomments,

        /*** tab-programs - OPC US PTS-Psy - Officer */
        'opcusptspsyofficercomments': this.props.currentFormState.opcusptspsyofficercomments,






        /*** tab-client-details */
        /*** tab-client-details - tab-conditions */
        'clienthomelesshistory': this.props.currentFormState.clienthomelesshistory,
        'clienthomelesscurrent': this.props.currentFormState.clienthomelesscurrent,
        'clienthomelessna': this.props.currentFormState.clienthomelessna,
        'clientmentalhealthissueshistory': this.props.currentFormState.clientmentalhealthissueshistory,
        'clientmentalhealthissuescurrent': this.props.currentFormState.clientmentalhealthissuescurrent,
        'clientmentalhealthissuesna': this.props.currentFormState.clientmentalhealthissuesna,
        'clientsubstanceusedisorderissueshistory': this.props.currentFormState.clientsubstanceusedisorderissueshistory,
        'clientsubstanceusedisorderissuescurrent': this.props.currentFormState.clientsubstanceusedisorderissuescurrent,
        'clientsubstanceusedisorderissuesna': this.props.currentFormState.clientsubstanceusedisorderissuesna,
        'clientcooccurringhistory': this.props.currentFormState.clientcooccurringhistory,
        'clientcooccurringcurrent': this.props.currentFormState.clientcooccurringcurrent,
        'clientcooccurringna': this.props.currentFormState.clientcooccurringna,
        'clientemployedduringpasthistory': this.props.currentFormState.clientemployedduringpasthistory,
        'clientemployedduringpastcurrent': this.props.currentFormState.clientemployedduringpastcurrent,
        'clientemployedduringpastna': this.props.currentFormState.clientemployedduringpastna,
        'clientprescribedmedications': this.props.currentFormState.clientprescribedmedications,
        'clientmedicationsupplyprovided': this.props.currentFormState.clientmedicationsupplyprovided,

        /*** tab-client-details - tab-education */
        'educationcompleted': this.props.currentFormState.educationcompleted,

        /*** tab-client-details - tab-referral */
        'referralsource': this.props.currentFormState.referralsource,
        'priorcriminalbackground': this.props.currentFormState.priorcriminalbackground,
        'currentinstantoffense': this.props.currentFormState.currentinstantoffense,

        /*** tab-client-details - tab-support */
        'supportsystem': this.props.currentFormState.supportsystem,
        'supportsystemcomments': this.props.currentFormState.supportsystemcomments,
        'numberofchildren': this.props.currentFormState.numberofchildren,
        'drugscreenscore': this.props.currentFormState.drugscreenscore,
        'primarybehavioralhealthdiagnosis': this.props.currentFormState.primarybehavioralhealthdiagnosis,
        'secondarybehavioralhealthdiagnosis': this.props.currentFormState.secondarybehavioralhealthdiagnosis,
        'behavioralhealthdiagnosiscomment': this.props.currentFormState.behavioralhealthdiagnosiscomment,
        'clienthomelesshowmanyweekspastyear': this.props.currentFormState.clienthomelesshowmanyweekspastyear,
        'clientemployedhowmanyweekspastyear': this.props.currentFormState.clientemployedhowmanyweekspastyear,
        'clientsourceofincome': this.props.currentFormState.clientsourceofincome,
        'clientrisktoselfothers': this.props.currentFormState.clientrisktoselfothers,
        'clientintakeandassessmentcomments': this.props.currentFormState.clientintakeandassessmentcomments,
        'clientrisktoselfotherscomment': this.props.currentFormState.clientrisktoselfotherscomment,
        'prescribedmedications': this.props.currentFormState.prescribedmedications,
        'medicationsupplyprovidedwithclient': this.props.currentFormState.medicationsupplyprovidedwithclient,
        'residentwithdisabilities': this.props.currentFormState.residentwithdisabilities,
        'clientisveteran': this.props.currentFormState.clientisveteran,
        'limitedenglishproficiency': this.props.currentFormState.limitedenglishproficiency,
        'limitedenglishproficiencycomments': this.props.currentFormState.limitedenglishproficiencycomments,
        'clientidentifiedsexualorientation': this.props.currentFormState.clientidentifiedsexualorientation,
        'interviewerperceptionofsexualorientation': this.props.currentFormState.interviewerperceptionofsexualorientation,



        /*** Client required */
        'refid': this.props.currentFormState.refid,
        'clientpostadmissiondate': this.props.currentFormState.clientpostadmissiondate,


        /*** Client Tabs Intake Assessment */
        'clientrecidivismriskscorenumber': this.props.currentFormState.clientrecidivismriskscorenumber,
        'clientrecidivismriskscorelevel': this.props.currentFormState.clientrecidivismriskscorelevel,
        'clientriskofvictimization': this.props.currentFormState.clientriskofvictimization,
        'clientriskasperpetrator': this.props.currentFormState.clientriskasperpetrator,
        'clientemployedduringprogram': 0,
        'clienthousingduringprogram': 0,
        
        'clientrrchdeligibilitydate': this.props.currentFormState.clientrrchdeligibilitydate,
        'clientbhtsopreferralcompleted': this.props.currentFormState.clientbhtsopreferralcompleted,


        /*** Client Tabs Crosspoint Programing */
        'clientlifeskills': this.props.currentFormState.clientlifeskills,
        'clientjobteadinesstraining': this.props.currentFormState.clientjobteadinesstraining,
        'clientcbtprogramming': this.props.currentFormState.clientcbtprogramming,
        'clientcbtprogramminghourscomplete':  this.props.currentFormState.clientcbtprogramminghourscomplete,
        'clientparenting': this.props.currentFormState.clientparenting,
        'clientwellness': this.props.currentFormState.clientwellness,
        'clientfinancialliteracy': this.props.currentFormState.clientfinancialliteracy,
        'crosspointbehavioralhealthservices': this.props.currentFormState.crosspointbehavioralhealthservices,


        /*** Client Tabs Voluntary Program Activities */
        'clientcommunityvolunteerprojects': this.props.currentFormState.clientcommunityvolunteerprojects,
        'clientcommunityvolunteerprojectscompleted':  this.props.currentFormState.clientcommunityvolunteerprojectscompleted,
        'clientaana': this.props.currentFormState.clientaana,
        'clientfaithbased': this.props.currentFormState.clientfaithbased,
        'clientadulteducation': this.props.currentFormState.clientadulteducation,
        'clientadulteducationcomments':  this.props.currentFormState.clientadulteducationcomments,
        'clientcompletedadulteducation': this.props.currentFormState.clientcompletedadulteducation,
        'clientrecoverycoachengagement': this.props.currentFormState.clientrecoverycoachengagement,
        'clientmedicationassistedtherapy': this.props.currentFormState.clientmedicationassistedtherapy,


        /*** Client Tabs Discharge / Termination */
        // 'clientdischargedate': this.props.currentFormState.clientdischargedate === '0000-00-00' ? null : this.props.currentFormState.clientdischargedate,
        'clientdischargedate': this.props.currentFormState.clientdischargedate,
        'clientemployedatdischarge': this.props.currentFormState.clientemployedatdischarge,
        'clienthousingatdischarge': this.props.currentFormState.clienthousingatdischarge,
        'clientdischargezipcode': this.props.currentFormState.clientdischargezipcode,
        'clientbehavioralhealthprogramsduringprogramstay': this.props.currentFormState.clientbehavioralhealthprogramsduringprogramstay,

        'clientearningshourlyrate': this.props.currentFormState.clientearningshourlyrate,
        'clientgrosssavings': this.props.currentFormState.clientgrosssavings,
        'clientbenefitapplicationinitiated': this.props.currentFormState.clientbenefitapplicationinitiated,
        'clientbenefitsawarded': this.props.currentFormState.clientbenefitsawarded,

        'clientrrctransfertohomeconfinement': this.props.currentFormState.clientrrctransfertohomeconfinement,
        'clientrrchomeconfinementatrelease': this.props.currentFormState.clientrrchomeconfinementatrelease,
        'clientrrcoverallgrossearningsytd': this.props.currentFormState.clientrrcoverallgrossearningsytd,
        'clientbhtssocialdeterminantsurvey': this.props.currentFormState.clientbhtssocialdeterminantsurvey,
        'clientbhtspostdischargeopenrolled': this.props.currentFormState.clientbhtspostdischargeopenrolled,
        
        'clientspotlightcandidate': this.props.currentFormState.clientspotlightcandidate,
        /*** FIXED cannot be changed and saved here ONLY in SAVE & CLOSE */
        'clientdischargestatus': 1,
        'clientdischargesubstatus': 0,
        'clientdischargestatuscomments': this.props.currentFormState.clientdischargestatuscomments,

        // 'clientlasttouchedbyloginid': this.props.currentUser.id,
        'clientlasttouchedbyloginid': c_USER.id,
        // 'clientlasttouchedbyloginid': contextType.id,

    };
                                                                    // console.log ('4444-505-878 - EditViewClient-AAA - handleSubmitSave - params = ', params);
    this.props.editClientSave(this.props.match.params.id, params);
  }


  handleSubmitSaveAndClose = (values, reset, dispatch) => {
    // console.log('aa zz gg cc = ');
    // console.log(values.clientdischargedate);
    // console.log(values);

              /*** signed in user */
              const c_USER = this.context  

    var params = {

      /*** tab-name */
      'regid': values.regid,
      'fname': values.fname,
      'mname': values.mname,
      'lname': values.lname,
      'dob': values.dob,
      'gender': values.gender,
      'ethnicity': values.ethnicity,

      /*** tab-address */
      'street': values.street,
      'city': values.city,
      'state': values.state,
      'zip': values.zip,

      'phonenumber': values.phonenumber,
      'emergencycontact': values.emergencycontact,
      'emergencycontactnumber': values.emergencycontactnumber,


        /*** tab-programs - BOP RRC - Officer */
        'bopsupervisingofficercomments': values.bopsupervisingofficercomments , 

        /*** tab-programs - BOP RRC - Program Requirements */
        'bopalchoholaftercareprogram': values.bopalchoholaftercareprogram , 
        'bopdrugaftercareprogram': values.bopdrugaftercareprogram , 
        'bopfinancialresponsibilityprogram': values.bopfinancialresponsibilityprogram , 
        'bopmentalhealthaftercareprogram': values.bopmentalhealthaftercareprogram , 
        'boppsf': values.boppsf , 

        /*** tab-programs - BOP RRC - BOP Institution */
        'boplevelofsecurity': values.boplevelofsecurity,
        'bopinstitution': values.bopinstitution,
        'bopinstitutioncomments': values.bopinstitutioncomments,

        /*** tab-programs - BOP RRC - Gang Affiliation */
        'bopgangaffiliation': values.bopgangaffiliation,
        'bopgangaffiliationcomments': values.bopgangaffiliationcomments,

        /*** tab-programs - OPC US PTS-Psy - Officer */
        'opcusptspsyofficercomments': values.opcusptspsyofficercomments,






        /*** tab-client-details */
        /*** tab-client-details - tab-conditions */
        'clienthomelesshistory': values.clienthomelesshistory,
        'clienthomelesscurrent': values.clienthomelesscurrent,
        'clienthomelessna': values.clienthomelessna,
        'clientmentalhealthissueshistory': values.clientmentalhealthissueshistory,
        'clientmentalhealthissuescurrent': values.clientmentalhealthissuescurrent,
        'clientmentalhealthissuesna': values.clientmentalhealthissuesna,
        'clientsubstanceusedisorderissueshistory': values.clientsubstanceusedisorderissueshistory,
        'clientsubstanceusedisorderissuescurrent': values.clientsubstanceusedisorderissuescurrent,
        'clientsubstanceusedisorderissuesna': values.clientsubstanceusedisorderissuesna,
        'clientcooccurringhistory': values.clientcooccurringhistory,
        'clientcooccurringcurrent': values.clientcooccurringcurrent,
        'clientcooccurringna': values.clientcooccurringna,
        'clientemployedduringpasthistory': values.clientemployedduringpasthistory,
        'clientemployedduringpastcurrent': values.clientemployedduringpastcurrent,
        'clientemployedduringpastna': values.clientemployedduringpastna,
        'clientprescribedmedications': this.props.currentFormState.clientprescribedmedications,
        'clientmedicationsupplyprovided': this.props.currentFormState.clientmedicationsupplyprovided,

        /*** tab-client-details - tab-education */
        'educationcompleted': values.educationcompleted,

        /*** tab-client-details - tab-referral */
        'referralsource': values.referralsource,
        'priorcriminalbackground': values.priorcriminalbackground,
        'currentinstantoffense': values.currentinstantoffense,

        /*** tab-client-details - tab-support */
        'supportsystem': values.supportsystem,
        'supportsystemcomments': values.supportsystemcomments,
        'numberofchildren': values.numberofchildren,
        'drugscreenscore': values.drugscreenscore,
        'primarybehavioralhealthdiagnosis': values.primarybehavioralhealthdiagnosis,
        'secondarybehavioralhealthdiagnosis': values.secondarybehavioralhealthdiagnosis,
        'behavioralhealthdiagnosiscomment': values.behavioralhealthdiagnosiscomment,
        'clienthomelesshowmanyweekspastyear': values.clienthomelesshowmanyweekspastyear,
        'clientemployedhowmanyweekspastyear': values.clientemployedhowmanyweekspastyear,
        'clientsourceofincome': values.clientsourceofincome,
        'clientrisktoselfothers': values.clientrisktoselfothers,
        'clientintakeandassessmentcomments': values.clientintakeandassessmentcomments,
        'clientrisktoselfotherscomment': values.clientrisktoselfotherscomment,
        'prescribedmedications': values.prescribedmedications,
        'medicationsupplyprovidedwithclient': values.medicationsupplyprovidedwithclient,
        'residentwithdisabilities': values.residentwithdisabilities,
        'clientisveteran': values.clientisveteran,
        'limitedenglishproficiency': values.limitedenglishproficiency,
        'limitedenglishproficiencycomments': values.limitedenglishproficiencycomments,
        'clientidentifiedsexualorientation': values.clientidentifiedsexualorientation,
        'interviewerperceptionofsexualorientation': values.interviewerperceptionofsexualorientation,


        /*** Client required */
        'refid': values.refid,
        'clientpostadmissiondate': values.clientpostadmissiondate,


        /*** Client Tabs Intake Assessment */
        'clientrecidivismriskscorenumber': values.clientrecidivismriskscorenumber,
        'clientrecidivismriskscorelevel': values.clientrecidivismriskscorelevel,
        'clientriskofvictimization': values.clientriskofvictimization,
        'clientriskasperpetrator': values.clientriskasperpetrator,
        'clientemployedduringprogram': 0,
        'clienthousingduringprogram': 0,
        
        'clientrrchdeligibilitydate': values.clientrrchdeligibilitydate,
        'clientbhtsopreferralcompleted': values.clientbhtsopreferralcompleted,


        /*** Client Tabs Crosspoint Programing */
        'clientlifeskills': values.clientlifeskills,
        'clientjobteadinesstraining': values.clientjobteadinesstraining,
        'clientcbtprogramming': values.clientcbtprogramming,
        'clientcbtprogramminghourscomplete':  values.clientcbtprogramminghourscomplete,
        'clientparenting': values.clientparenting,
        'clientwellness': values.clientwellness,
        'clientfinancialliteracy': values.clientfinancialliteracy,
        'crosspointbehavioralhealthservices': values.crosspointbehavioralhealthservices,


        /*** Client Tabs Voluntary Program Activities */
        'clientcommunityvolunteerprojects': values.clientcommunityvolunteerprojects,
        'clientcommunityvolunteerprojectscompleted':  values.clientcommunityvolunteerprojectscompleted,
        'clientaana': values.clientaana,
        'clientfaithbased': values.clientfaithbased,
        'clientadulteducation': values.clientadulteducation,
        'clientadulteducationcomments':  values.clientadulteducationcomments,
        'clientcompletedadulteducation': values.clientcompletedadulteducation,
        'clientrecoverycoachengagement': values.clientrecoverycoachengagement,
        'clientmedicationassistedtherapy': values.clientmedicationassistedtherapy,


        /*** Client Tabs Discharge / Termination */
        // 'clientdischargedate': values.clientdischargedate === '0000-00-00' ? null : values.clientdischargedate,
        // 'clientdischargedate': values.clientdischargedate === 'Invalid Date' ? null : values.clientdischargedate,
        'clientdischargedate': values.clientdischargedate,
        'clientemployedatdischarge': values.clientemployedatdischarge,
        'clienthousingatdischarge': values.clienthousingatdischarge,
        'clientdischargezipcode': values.clientdischargezipcode,
        'clientbehavioralhealthprogramsduringprogramstay': values.clientbehavioralhealthprogramsduringprogramstay,

        'clientearningshourlyrate': values.clientearningshourlyrate,
        'clientgrosssavings': values.clientgrosssavings,
        'clientbenefitapplicationinitiated': values.clientbenefitapplicationinitiated,
        'clientbenefitsawarded': values.clientbenefitsawarded,

        'clientrrctransfertohomeconfinement': values.clientrrctransfertohomeconfinement,
        'clientrrchomeconfinementatrelease': values.clientrrchomeconfinementatrelease,
        'clientrrcoverallgrossearningsytd': values.clientrrcoverallgrossearningsytd,
        'clientbhtssocialdeterminantsurvey': values.clientbhtssocialdeterminantsurvey,
        'clientbhtspostdischargeopenrolled': values.clientbhtspostdischargeopenrolled,
        
        'clientspotlightcandidate': values.clientspotlightcandidate,
        'clientdischargestatus': values.clientdischargestatus,
        'clientdischargesubstatus': values.clientdischargesubstatus,
        'clientdischargestatuscomments': values.clientdischargestatuscomments,

        // 'clientlasttouchedbyloginid': this.props.currentUser.id,
        'clientlasttouchedbyloginid': c_USER.id,
        // 'clientlasttouchedbyloginid': contextType.id,

    };
                                                                              // console.log ('4444-404-894 - EditViewClient-AAA - handleSubmitSaveAndClose - this.props.match.params.id = ', this.props.match.params.id);
                                                                              // console.log ('4444-404-890 - EditViewClient-AAA - handleSubmitSaveAndClose - params = ', params);
    switch (values.clientdischargestatus) {
      case 2:
      case '2':
              /*** Save to Archive */
              /*** Successful - Save / Move to Post Discharged */
        this.props.transferClientToCients(this.props.match.params.id, params);
        break;
      case 3:
      case '3':
              /*** Unsuccessful - Save to Archive */
        this.props.archiveClient(this.props.match.params.id, params);
        break;
      case 4:
      case '4':
              /*** Neutral - Save to Archive */
        this.props.archiveClient(this.props.match.params.id, params);
        break;
      default:
              /*** default - Pending - just save pending entry */
        this.props.editClientSaveAndClose(this.props.match.params.id, params);
        break;
    }

  }


  render() {

                                                                                                  // console.log ('4444-2434 - ClientEdit - Props = ', this.props);
                                                                                                  // // console.log ('4444-2435 - ClientEdit - State = ', this.state);
                                                                                                  // console.log ('4444-2436 - ClientEdit - this.props.valid = ', this.props.valid);


                                                                                                  // console.log ('4444-3413 - ClientEdit - Props = ', this.props);
                                                                                                  // if (typeof this.props.client === "undefined")
                                                                                                  // {} else { 
                                                                                                  //   // console.log ('4444-3415 - ClientEdit - Props.singleTest = ', this.props.client.dob );
                                                                                                  //   console.log ('4444-3415 - ClientEdit - Props.singleTest = ', new Date(this.props.client.dob) );
                                                                                                  // }


                                                                                                  // if (this.props.clients.updatesSavedOnly) {
                                                                                                  //   let errors = {};
                                                                                                  //   errors.notifyFormErrors = 'Update Saved';
                                                                                                  //   throw errors;
                                                                                                  // }

                                                                                                  // /*** test - start */
                                                                                                  //   let savednotification = {};
                                                                                                  //   savednotification.notifyFormErrors = 'Update Saved';
                                                                                                  //   throw savednotification;
                                                                                                  // /*** test - end */

    return (
      <form onSubmit={this.props.handleSubmit(this.handleSubmitSaveAndClose)}>
        <div >

          <AppBar position="static" color="default">

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <ButtonSave
                  size='large'
                  fullWidth
                  onClick={() => {
                    this.handleSubmitSave()
                  }}
                  disabled={!this.props.valid || this.props.clientMode === 3}
                >
                  <Save />
                  &nbsp;
                  Save
                </ButtonSave> 
              </Grid>
              <Grid item xs={12} sm={6}>
                <ButtonSaveAndClose
                  type='submit'
                  size='large'
                  fullWidth
                  disabled={!this.props.valid || this.props.clientMode === 3}
                >
                  <SaveAltIcon />
                  &nbsp;
                  Save & Close
                </ButtonSaveAndClose>
              </Grid>
            </Grid> 

            {this.props.loadingList && <LinearProgress variant="buffer"  value={5} valueBuffer={10} color="secondary" /> }

            <Field
              component={renderSnackbarSavedNotification}
              id='notifyFormSavedNotifications'
              name='notifyFormSavedNotifications'
            />
{/* 
                                                                          <Field
                                                                            component={renderSnackbarError}
                                                                            id='notifyFormErrors'
                                                                            name='notifyFormErrors'
                                                                          />
 */}
            <Tabs
              value={this.state.headerTabs}
              onChange={this.handleChangeHeader1}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
                                                                        // scrollButtons="auto"
              scrollButtons="on"
            >
              <Tab label="Name" />
              <Tab label="Programs" />
              <Tab label="All Program Details" />

              <Tab label="Intake & Assessment" />
              <Tab label="Crosspoint Programing" />
              <Tab label="Voluntary Program Activities" />
              <Tab label="Discharge / Termination" />

              <Tab label="Dates" />
              <Tab label="Referral Outcome" />
              <Tab label="Change Log" />
            </Tabs>
          </AppBar> 


          <Field
              component={renderSnackbarError}
              id='notifyFormErrors'
              name='notifyFormErrors'
            />


          {this.state.headerTabs === 0 && <TabContainer>
            <EditViewClientTabName
              locked={this.props.clientMode === 3 ? true : false}
            />
            <EditViewClientTabAddress
              locked={this.props.clientMode === 3 ? true : false}
            />
          </TabContainer>} 

          {this.state.headerTabs === 1 && <TabContainer>
            <EditViewClientTabPrograms
              locked={this.props.clientMode === 3 ? true : false}
              programSelected={this.props.initialValues.program}
              
              programsList={this.props.programsList.programs}
              // bopinstitutionsList={this.props.bopinstitutionsList.bopinstitutions}
              // gangaffiliationsList={this.props.gangaffiliationsList.gangaffiliations}
              bopinstitutionsList={this.props.bopinstitutionsList}
              gangaffiliationsList={this.props.gangaffiliationsList}

              allowChangeProgram={this.props.clientMode !== 3 ? true : false}
              handleSubmitChangeProgram={this.handleSubmitChangeProgram}
            /> 
          </TabContainer>}

          {this.state.headerTabs === 2 && <TabContainer>
            <EditViewClientTabClientDetails
              locked={this.props.clientMode === 3 ? true : false}
              // referralsourcesList={this.props.referralsourcesList.referralsources}
              referralsourcesList={this.props.referralsourcesList}
            />
          </TabContainer>}

          {this.state.headerTabs === 3 && <TabContainer>
            <EditViewClientTabIntakeAssessment
              locked={this.props.clientMode === 3 ? true : false}
              programSelected={this.props.initialValues.program}
            />
          </TabContainer>}

          {this.state.headerTabs === 4 && <TabContainer>
{/*             
            <FormFieldsClientsTabsTabResidentialCMPrograms locked={this.props.clientMode === 3 ? true : false} />
 */}
            <EditViewClientTabResidentialCMPrograms
              locked={this.props.clientMode === 3 ? true : false}
            />            
          </TabContainer>}

          {this.state.headerTabs === 5 && <TabContainer>
            <EditViewClientTabVoluntaryProgramActivity
              locked={this.props.clientMode === 3 ? true : false}
            />
          </TabContainer>}

          {this.state.headerTabs === 6 && <TabContainer>
            <EditViewClientTabDischargeTermination
              locked={this.props.clientMode === 3 ? true : false}
              programSelected={this.props.initialValues.program}
              clientdischargedateSelected={this.props.currentFormState === undefined ? this.props.initialValues.clientdischargedate : this.props.currentFormState.clientdischargedate}
            />
          </TabContainer>}

          {this.state.headerTabs === 7 && <TabContainer>
            <EditViewClientTabDates
              locked={true}
              referraloutcome={this.props.initialValues.referraloutcome}
              clientdischargestatus={this.props.initialValues.clientdischargestatus} 
            />
          </TabContainer>}

          {this.state.headerTabs === 8 && <TabContainer>
            <EditViewClientTabOutcome
              locked={true}
            />
          </TabContainer>} 

          {this.state.headerTabs === 9 && <TabContainer>
            <EditViewClientTabChangeLog
            />
          </TabContainer>}

          {this.props.loadingList && <LinearProgress variant="buffer"  value={5} valueBuffer={10} color="secondary" /> }

          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <ButtonSave
                size='large'
                fullWidth
                onClick={() => {
                  this.handleSubmitSave()
                }}
                disabled={!this.props.valid || this.props.clientMode === 3}
              >
                <Save />
                &nbsp;
                Save
              </ButtonSave> 
            </Grid>
            <Grid item xs={12} sm={6}>
              <ButtonSaveAndClose
                type='submit'                
                size='large'
                fullWidth
                disabled={!this.props.valid || this.props.clientMode === 3}
              >
                <SaveAltIcon />
                &nbsp;
                Save & Close
              </ButtonSaveAndClose>
            </Grid>
          </Grid>


        </div>
      </form>
    );
  }
}
ClientEdit.propTypes = {
  /*** Client Type - 0 - add - 1 - edit - 2 - view */
  clientMode: PropTypes.number,
  addClient: PropTypes.func,
  editClientSave: PropTypes.func,
  editClientSaveAndClose: PropTypes.func,
  transferClientToCients: PropTypes.func,
  archiveClient: PropTypes.func,
};
ClientEdit = reduxForm({
  form: 'ClientEditForm', // a unique name for this form
  /*** validate form values */
  asyncValidate,
  /*** double render issue */
  enableReinitialize: true,
  // /*** preserve form data */
  // destroyOnUnmount: false,
  // /*** unregister fields on unmount */
  // forceUnregisterOnUnmount: true,
})(ClientEdit);
export default withRouter(ClientEdit);
